import React from 'react';
import { Reveal } from './Reveal';
import { WHY } from '../data/site';
import { Check } from 'lucide-react';

export default function WhyUs() {
  return (
    <section id="why" className="relative py-32 md:py-48 px-6 md:px-10 max-w-[1600px] mx-auto" data-testid="why-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10">
        <Reveal className="col-span-12 md:col-span-3">
          <div className="flex md:flex-col items-baseline md:items-start gap-4">
            <span className="font-mono text-gold text-sm tracking-[0.3em]">05 —</span>
            <span className="overline">Pourquoi nous</span>
          </div>
        </Reveal>
        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif leading-[0.95] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 6vw, 6rem)' }}>
            Six raisons — <span className="italic text-char/50">et un fil conducteur.</span>
          </h2>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
            {WHY.map((w, i) => (
              <Reveal key={w} delay={i * 0.06}>
                <div className="group flex items-start gap-5 py-5 border-b border-char/10 hover:border-gold/40 transition-colors duration-500">
                  <div className="w-9 h-9 flex-shrink-0 border border-gold/50 text-gold flex items-center justify-center group-hover:bg-gold group-hover:text-cream transition-colors duration-500">
                    <Check size={16} strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-mono text-gold text-[10px] tracking-[0.3em] mb-1">
                      {String(i + 1).padStart(2, '0')}
                    </div>
                    <div className="text-lg md:text-xl font-light">{w}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
